import { darken } from 'polished';
import styled from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { Div, FlexRow } from 'common/styles/oc-styled-components';
import {
  BREAKPOINTS,
  colors,
  DARKEN_AMOUNT,
} from 'common/styles/style-constants';

export const Block = styled.section`
  margin: 0 0 50px 0;

  h3 {
    color: ${colors.slate};
    font-size: 20px;
    ${TYPOGRAPHY.CIRCULAR.bold}
    margin: 0 0 30px 0;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin: 0 0 30px 0;

    h3 {
      font-size: 18px;
    }
  }
`;

export const IconCircle = styled(Div)`
  align-items: center;
  background: ${(props) => props.background};
  border-radius: 50px;
  display: flex;
  justify-content: center;
`;

export const Info = styled(FlexRow)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;
  }
`;

export const SuperPracticeBlock = styled.section`
  margin: 0 0 50px 0;

  svg {
    fill: ${colors.blue};
  }

  h3 {
    position: relative;
    top: 4px;
    display: inline-block;
    color: ${colors.blue};
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  a {
    color: ${colors.sageDark};
    border-bottom: 1px solid transparent;
    transition: all 0.25s;

    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      display: block;
    }

    &:hover {
      color: ${darken(DARKEN_AMOUNT, colors.sageDark)};
      border-color: ${darken(DARKEN_AMOUNT, colors.sageDark)};
    }
  }
`;

export const SuperPracticeText = styled(Div)`
  text-align: left;
`;
